import React from 'react';

export const Option = ({ value, label }) => (
    <option value={value}>{label}</option>
);


// WEBPACK FOOTER //
// ./Public/src/js/component/rfc/children/select-option.js